import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form  } from 'formik';
import * as Yup from 'yup';
import {ERR,TIPO_EVENTO, LoadingBoton,PERIODO,TIPO_ACCION, TIPO_INFORMACION,TIPO_NOTIFICACION} from '../../_helpers';
import { eventoService} from '../../_services';
import {accionColectivaActions, alertActions,equipoActions,eventoActions, utilActions} from '../../_actions';
import {Row,Col} from 'react-bootstrap';
import Moment from 'moment'
import momentLocalizer from 'react-widgets-moment';
import { sensorConstants } from '../../_constants';
import { Paso0 } from './Pasos/Paso';
import { Paso3 } from './Pasos/Paso3';
import { Paso4 } from './Pasos/Paso4';

Moment.locale('es')
momentLocalizer()

class FormEvento extends React.Component {
  
  constructor(props){
    super(props)
  }

  componentDidMount(){  
    if(this.props.tiposSensores===undefined)this.props.traerTiposSensores();
    if(this.props.tiposNotificaciones===undefined)this.props.traerListadoGeneralEvento();
    if(this.props.accionColectiva.misAcciones===undefined)this.props.traerAccionesColectivas();
  }

  state = {
      page:0,
      tipoSensores: [{id:'', descripcion:''}],
      errorPaso2:'',
      errorPaso4:'',
      grabando:false
  };

  pasarPagina = () => {   
      this.setState(() => {
        return {
            page: this.state.page+1,
            errorPaso2: '',
            errorPaso4: ''
          };
      });
  }

  volverPagina = () => {   
    if (this.state.page!==0){
      this.setState(() => {
        return {
            page: this.state.page-1
          };
      });
    }
   
}
render() {
      const {evento,equipos,user} = this.props;
      const {page} = this.state;
      const options = [];
      const optionsSimple = [];
      const optionsSimpleToogle = [];
      
      const cantidadPasos=3;

      const sensoresL = equipos.sensores;

      equipos.misEquipos.forEach((eq, index) => { 
          const sensoresEq = [];
          if(eq.sensores){
          eq.sensores.forEach((sensor, index) => { 
            const s = utilActions.extraerDeLista(sensor.id,sensoresL);
            sensoresEq.push( {name: s.labelUsuario, value: (sensor.id+'')})
            optionsSimple.push( {descripcion: s.labelUsuario, id: (sensor.id)})
            if(s.shadows[0].tipoWidget.id===sensorConstants.TIPO_WIDGET_TOOGLE)optionsSimpleToogle.push( {descripcion: s.labelUsuario, id: (sensor.id)});
          }); 
        }

          if(sensoresEq.length>0){
            const grupo ={
              type: 'group',
              name: eq.nombre,
              items: sensoresEq
            }
            options.push(grupo)
          }      
      }); 


      let inic={
        id:'',
        nombre: '',
        valor:'',
        tipoSensor:{id:''},
        sensor:{id:''},
        sensores: [],
        acciones: [],
        condicion:{id:''},
        periodo:{id:''},
        tipoEvento:{id:''},
        hora:0,
        minuto:0,
        diaSemana:[],
        diaMes:'',
        tiposInformaciones:[],
        tiposNotificaciones:[]
      }

      const vSchemaPaso0 = Yup.object().shape({
        nombre: Yup.string()
          .min(2, 'Muy corto')
          .max(50, 'Muy largo')
          .required('Requerido'),
        tipoEvento: Yup.object({id: Yup.string().required(ERR.REQ)})
      });
      
      const vSchemaPaso1 = Yup.object().shape({
        sensor: Yup.object().when('tipoEvento', {
          is: (val) => val.id == TIPO_EVENTO.AUTOMATICO, 
          then: Yup.object({id: Yup.string().required(ERR.REQ)})
        }),
        condicion: Yup.object().when('tipoEvento', {
          is: (val) => val.id == TIPO_EVENTO.AUTOMATICO, 
          then: Yup.object({id: Yup.string().required(ERR.REQ)})
        }),
        valor: Yup.string().when('tipoEvento', {
          is: (val) => val.id == TIPO_EVENTO.AUTOMATICO, 
          then: Yup.string().required(ERR.REQ).max(50,ERR.MAX+" 50")
        }),
        periodo: Yup.object().when('tipoEvento', {
          is: (val) => val.id == TIPO_EVENTO.PROGRAMADO, 
          then: Yup.object({id: Yup.string().required(ERR.REQ)})
        }),
        diaSemana: Yup.array().when('periodo', {
          is: (val) => val.id == PERIODO.SEMANAL, 
          then: Yup.array().required(ERR.REQ).min(1,'Debe seleccionar al menos un día')
        }),
        hora: Yup.string().when('tipoEvento', {
          is: (val) => val.id == TIPO_EVENTO.PROGRAMADO, 
          then: Yup.string().required(ERR.REQ)
        }),
      });
      
      const vSchemaPaso2 = Yup.object().shape({
        acciones:Yup.array().required(ERR.REQ).min(1,'Debe definir al menos una acción').of(
          Yup.object().shape({
            tipoAccion: Yup.object({id: Yup.string().required(ERR.REQ)}),
            tiposNotificaciones: Yup.array().when('tipoAccion', {
              is: (val) => val.id == TIPO_ACCION.NOTIFICACION, 
              then: Yup.array().required(ERR.REQ).min(1,'Debe definir al menos una notificación').of(
                Yup.object({id: Yup.string().required(ERR.REQ)}))
            }),
            tiposInformaciones: Yup.array().test('tiposInformaciones','', function(item,schema){      
               
              if(inic.tipoEvento.id==TIPO_EVENTO.PROGRAMADO && this.parent.tipoAccion.id == TIPO_ACCION.NOTIFICACION && (item===undefined || item.length===0)){
                
                return this.createError({
                  path:`tiposInformaciones`,
                  message:'Debe seleccionar al menos una opción 1'
                })
              }               
             }),
             sensores: Yup.array().test('sensores','', function(item){
              if ((item===undefined || item.length===0) &&((inic.tipoEvento.id===TIPO_EVENTO.PROGRAMADO && this.parent.tipoAccion.id == TIPO_ACCION.NOTIFICACION) || this.parent.tipoAccion.id == TIPO_ACCION.PARTICULAR)){
                
                return this.createError({
                   path:`sensores`,
                   message:'Debe seleccionar al menos un sensor'
                 })
                }
             }),
            accionesColectivas: Yup.array().when('tipoAccion', {
              is: (val) => val.id == TIPO_ACCION.COLECTIVA, 
              then: Yup.array().min(1,'Debe definir al menos una accion colectiva').of(
                Yup.object({id: Yup.string().required(ERR.REQ)}))
            }),
            tipoAccionColectiva: Yup.object().when('tipoAccion', {
              is: (val) => val.id == TIPO_ACCION.PARTICULAR, 
              then: Yup.object({id: Yup.string().required(ERR.REQ)})
            }),
            minutosEspera: Yup.number().typeError('Solo números').test('minutosEspera','', function(item,schema){
             if(inic.tipoEvento.id===TIPO_EVENTO.AUTOMATICO && (item===undefined || item===''))
                return this.createError({
                  path:`${this.path}`,
                  message:'Requerido'
                })
            })
          })
        )
      
      });
      
      const validationSchemas=[];
      validationSchemas.push(vSchemaPaso0);
      validationSchemas.push(vSchemaPaso1);
      validationSchemas.push(vSchemaPaso2);

      if(evento!==undefined)inic=utilActions.setearValores(inic,evento);
     
return(

  <div className="th_arandano">
       <div className="row">
          <div className="col-xs-12"> 
            <ul className="nav nav-tabs process-model more-icon-preocess" role="tablist">
                <li className={page===0?'active':''}>
                  <span>1</span>
                </li>
                <li className={page===1?'active':''}>
                  <span>2</span>
                </li>
                <li className={page===2?'active':''}>
                  <span>3</span>
                </li>             
              </ul>
            </div>
        </div>
        <div className="mt-8 steps">
            <Formik
              enableReinitialize= {true}
              initialValues={inic}
              validationSchema={validationSchemas[page]}
              onSubmit={values => {
                 
                  if(page === cantidadPasos -1){
                    this.setState({grabando:true});  

                      if(values.tipoEvento.id===TIPO_EVENTO.AUTOMATICO){
                          values.acciones.forEach((acc, i1) => { 
                            acc.tiposInformaciones = [{id:TIPO_INFORMACION.EVENTO}];         
                          });
                       }
                      eventoService.grabarEvento(values).then(
                        data => {  
                            this.props.agregarEventoGenerado(data,values.id==='');
                            this.props.handleClose();
                            this.setState({grabando:false});       
                        },
                        error=>{
                          this.props.enviarError(error);
                          this.setState({grabando:false});       
                        }
                    );
                    
                  }else{
                    this.pasarPagina();
                  }
                   
              }}
            >
              {({ values, setFieldValue }) => (
                <Row>
                  <Col xs={12}>
                    <Form>

                      {page===0 &&
                          <Paso0 values={values} state={this.props} setFieldValue={setFieldValue}/>
                      }
                      {page===1 && 
                          <>
                          <Paso3 values={values} equipos={this.props.equipos} state={this.props} optionsSensores={options} setFieldValue={setFieldValue}/>
                          </>
                      }
                      {page===2 &&                      
                          <>
                            <Paso4 user={user} values={values} state={this.props} accionColectiva={this.props.accionColectiva} optionsSensores={options} optionsSimple={optionsSimple} optionsSimpleToogle={optionsSimpleToogle} setFieldValue={setFieldValue}/>
                            {this.state.errorPaso4}
                          </>
                      }
                          
                        <div className="justify-content-center mt-5 p-3 row border-top bg-light">
                            <button className="btn btn-link text-secundario cursor mr-3" type="button" onClick={() => this.props.handleClose()}>
                                <i className="icon-times"></i> Cerrar
                            </button>
                            {page!==0 &&
                              <button className="btns btns-silver mr-3" type="button" onClick={()=>this.volverPagina()}>
                                  <i className="icon-chevron-left-outline"></i> Volver
                              </button>
                            }
                            {page === cantidadPasos -1 ?                             
                              <button className="btns btns-secundario  mr-3" type="submit" disabled={this.state.grabando}>
                                  <i className="icon-floppy"></i> Grabar
                                  <LoadingBoton grabando={this.state.grabando}/>
                              </button>                             
                              :                    
                              <button className="btns btns-arandano  mr-3" type="submit">
                                <i className="icon-chevron-right-outline"></i> Siguiente
                              </button>
                            }
                          
                        </div>
                        
                    </Form>
                  </Col>
                </Row>
              )}
            </Formik>
    </div>
  </div>
)};
}

function mapState(state) {
  const { userData } = state.authentication;
  const user = userData;
  const { equipos, accionColectiva } = state;
  const { tiposNotificaciones,condiciones,tiposInformaciones,periodos,tiposAccionesColectivas,tiposAcciones} = state.evento;
  const { tiposSensores} = equipos;
  return { user,equipos,accionColectiva,tiposSensores,tiposNotificaciones,condiciones,tiposInformaciones,periodos,tiposAccionesColectivas,tiposAcciones };
}

const actionCreators = {
  agregarEventoGenerado:eventoActions.agregarEventoGenerado,
  traerTiposSensores: equipoActions.traerTiposSensores,
  traerAccionesColectivas:accionColectivaActions.getAccionesColectivasPU,
  enviarError:alertActions.enviarError,
  traerListadoGeneralEvento:eventoActions.traerListadoGeneralEvento
}

const connectedFormEvento = connect(mapState, actionCreators)(FormEvento);
export { connectedFormEvento as FormEvento };